import React, { PureComponent } from "react";
import { userStyles } from "../styles";
import { WithStyles, withStyles } from "@material-ui/core";
import DialogLarge from "../common/DialogLarge";
import { Grid } from "@material-ui/core";
import OrderNotes from "./OrderNotes";
import { connect } from "react-redux";
import SectionInContent from "../common/SectionInContent";
import SectionInContentItem from "../common/SectionInContentItem";
import RequestInfo from "../components/RequestInfo";
import SelectContentOwners from "../components/SelectContentOwners";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import { getContentSubType } from "../../test-template/actions/testTemplateActions";
import _ from "lodash";
import { ContentRequest, Owners, Subject } from "../types/ContentRequest";
import { RequestContentType } from "../types/ContentRequestCreate";
import { RouteComponentProps } from "react-router-dom";
import contentRequestServices from "../services/contentRequestServices";
import {
  generateDefaultContentRequest,
  isLoggedInUserMultiCenterHead,
  prePublishRequestModifications,
  preSaveRequestModifications,
  validateSelectContentOwners,
  convertRequestPriorityToDislayValue,
  getAssignorName,
  getRequestCreatorName,
  getAuthUserClientId,
  getRelevantSubjects,
  extractUserIdsFromRequest,
} from "../helpers/createContentRequest";
import { bindActionCreators } from "redux";
import { fetchSubjects, addSubject } from "../actions/contentRequestActions";
import { Tabs } from "../types/Constants";
import { setActiveTab } from "../actions/contentRequestActions";
import dateService from "../../common/services/dateService";
import { contentRequestCreateActions } from "../reducers/contentRequestCreateReducer";
import MyPATTruncateText from "../../common/MyPATTruncateText";
import MyPATCollapseSection from "../../common/MyPATCollapseSection";
import MyPATCollapseSectionItem from "../../common/MyPATCollapseSectionItem";
import classNames from "classnames";

// interface Props extends WithStyles<typeof userStyles> {
//     classes:any;
//     contentRequest:ContentRequest,
//     getContentSubType:Function,
//     user:any
// }
interface RouteParams {
  requestContentType: RequestContentType;
  requestId: string;
}
interface Props
  extends WithStyles<typeof userStyles>,
    RouteComponentProps<RouteParams> {
  contentsubType: ContentSubType[];
  getContentSubType: (subType: string) => void;
  fetchOwners: () => void;
  user: any;
  contentRequest: ContentRequest;
  addSubject: Function;
  fetchSubjects: Function;
  isShowHeader?: boolean;
  setActiveTab: (tab: Tabs) => void;
  selectedQuestionCodes: string[];
  setSelectedQuestionCodes: (questionCodes: string[]) => void;
}
interface State {
  requestData: ContentRequest;
  isRequestForMyOrg: boolean;
  loading: boolean;
  areAllSectionsValid: boolean;
  relevantSubjects: Subject[];
  toShowTestOwners: boolean;
}

class EditCreateOwner extends PureComponent<Props, State> {
  isCenterHead: boolean;
  requestContentType: RequestContentType;
  requestId: string;
  existingUserIds: Set<string>;

  constructor(props: any) {
    super(props);
    this.requestContentType = props.match.params.requestContentType;
    this.isCenterHead = true;

    this.requestId = props.match.params.requestId;

    this.state = {
      requestData: generateDefaultContentRequest(this.requestContentType),
      isRequestForMyOrg: this.isCenterHead ? true : false,
      loading: true,
      areAllSectionsValid: false,
      relevantSubjects: [],
      toShowTestOwners: false
    };
    this.existingUserIds = new Set(); // Used for determining users for which isEmailTriggered will be sent as true
  }

  componentDidMount() {
    if (this.requestContentType === RequestContentType.TEST) {
      this.props.getContentSubType("testpapers");
    } else {
      this.props.getContentSubType("question");
    }
    this.fetchRequestData();
    this.props.fetchSubjects();
  }

  

  toShowTestOwners = (requestData: ContentRequest) => {
    const userClientId = getAuthUserClientId();

    const { owners=[] } = requestData.requestInfo;
    const owner = owners.find((owner: Owners) => {
      return owner.type === 'test-compiler';
    }); 

    return !!owner && owner.client.id === userClientId;
  }

  fetchRequestData = async () => {
    try {
      const response = await contentRequestServices.getRequestProgress(
        this.requestId,
        isLoggedInUserMultiCenterHead(),
        true
      );
      const { user } = this.props;
      const userClientId = _.get(user, "clientId._id", "");

      const { owners } = response.contentRequestDetails.requestInfo;
      let isRequestForMyOrg = !owners || owners.length === 0 ? false : true;
      for (let owner of owners) {
        const ownerClientId = _.get(owner, "client.id", "");
        if (userClientId && ownerClientId && userClientId !== ownerClientId) {
          isRequestForMyOrg = false;
          break;
        }
      }
      
      const subjects: Subject[] = getRelevantSubjects(response.contentRequestDetails);
      const toShowTestOwners = this.toShowTestOwners(response.contentRequestDetails)
      const courses = _.get(
        response.contentRequestDetails,
        "requestInfo.details.courseTypes",
        []
      );
      // Set selected question codes to redux to be used in ContentOwnersTable
      // To limit possible question codes in the select drop down
      const selectedQuestionCodeSet = subjects.reduce((acc, subject) => {
        subject.questions.forEach(({ code }) => {
          acc.add(code.toString());
        });

        return acc;
      }, new Set<string>());
      this.props.setSelectedQuestionCodes(Array.from(selectedQuestionCodeSet));
      const initiallySelectedSubjectIds: string[] = subjects.map(
        ({ id }) => id
      );
      this.props.addSubject(initiallySelectedSubjectIds);

      const coursesIds: any = [];
      courses.forEach((course: any) => {
        coursesIds.push(course.id);
      });
      const courseId = coursesIds.join(",");
      this.props.fetchSubjects(courseId);
      const requestData = response.contentRequestDetails;
      
      this.existingUserIds = extractUserIdsFromRequest(requestData);

      this.setState({
        requestData,
        isRequestForMyOrg,
        relevantSubjects: subjects,
        toShowTestOwners
      });
    } catch (error) {
      console.log(error);
    }
    this.setState({
      loading: false,
    });
  };
  handleOwnerChange = (requestData: ContentRequest) => {
    this.setState({
      requestData,
    });
  };
  onJobDone = async () => {
    try {
      const { user } = this.props;
      const preSaveModifiedRequestData = await preSaveRequestModifications({
        ...this.state.requestData,
        status: "published",
        publishedOn: new Date(),
      });
      const finalRequestPayload = prePublishRequestModifications(
        preSaveModifiedRequestData,
        user,
        { isRequestForMyOrg: false, useRelevantSubjects: this.isCenterHead, existingUserIds: this.existingUserIds }
      );
      await contentRequestServices.updateContentRequest(finalRequestPayload);
      this.props.history.push("/contentRequest");
      this.props.setActiveTab(Tabs.SentRequest);
    } catch (error) {
      console.log(error);
    }
  };
  onSectionsValidtyChange = (areAllSectionsValid: boolean) => {
    this.setState({
      areAllSectionsValid,
    });
  };
  getSubjectsName = () => {
    const names: string[] = [];
    const subjects = this.state.relevantSubjects;

    subjects.forEach((subject: any) => {
      names.push(_.capitalize(subject.name));
    });

    return names.length > 0 ? names : ["N/A"];
  };
  getTopNavValue = () => {
    const goalOwnerData = _.get(
      this.state.requestData,
      "requestInfo.details.courseTypes",
      []
    ).map((coursetype: any) => coursetype.name);
    const priority = _.get(this.state, "requestData.requestInfo.priority", "");
    const priorityDisplayValue = convertRequestPriorityToDislayValue(priority);
    let topNavValue = {
      Priority: priorityDisplayValue,
      Deadline:
        !_.isEmpty(this.state.requestData) &&
        _.get(this.state.requestData.requestInfo, "endDate", "") !== null &&
        dateService.dateFromString(
          _.get(this.state.requestData.requestInfo, "endDate", "")
        ),
      Goal: !_.isEmpty(this.state.requestData) && (
        <MyPATTruncateText
          data={goalOwnerData}
          truncateLength={15}
          displayCount={1}
        />
      ),
      "Content Request for": (
        <MyPATTruncateText
          data={this.getSubjectsName()}
          truncateLength={11}
          displayCount={2}
        />
      ),
      "Assigned by":
        !_.isEmpty(this.state.requestData) &&
        _.get(
          this.state.requestData.requestInfo,
          "details.subjects[0].assignor.name",
          ""
        ),
    };
    return topNavValue;
  };


  render() {
    const {
      classes,
      contentsubType,
      match: {
        params: { requestContentType = RequestContentType.TEST },
      },
    } = this.props;
    const { requestData, areAllSectionsValid, loading, relevantSubjects, toShowTestOwners } = this.state;

    const title = _.get(requestData, "title", "");
    const requestId = _.get(requestData, "requestId", "");

    if (loading) {
      return null;
    }
    return (
      <>
        <DialogLarge
          headerTitle={`${requestId}| ${title}`}
          isShowHeader={true}
          isFooter
          footerCTAName="Send Request"
          onJobDone={this.onJobDone}
          isJobDoneDisabled={!areAllSectionsValid}
          isSaveHidden
          isEditHidden
          topNavValue={this.getTopNavValue()}
        >

          <Grid className={classes.marginTop20} container spacing={24}>
            <Grid item xs={2}>
            <SectionInContent
                  onSectionsValidtyChange={this.onSectionsValidtyChange}
                  showDraftPercentage
                >
                  <SectionInContentItem
                    value={requestData}
                    validate={(data: any) => validateSelectContentOwners(data, { relevantSubjects, includeSubjectValidation: relevantSubjects.length > 0, includeTestOwnerValidation: toShowTestOwners, handleRelevantOwnerOnly: true })}
                    sectionId="selectContentOwners"
                  >
                    Select Content Owners
                  </SectionInContentItem>
                </SectionInContent>
            </Grid>
            <Grid item xs={9}>
              <OrderNotes
                testName={
                  requestData &&
                  requestData.requestInfo &&
                  requestData.requestInfo.details &&
                  requestData.requestInfo.details.testDetails &&
                  requestData.requestInfo.details.testDetails.name
                }
                subjects={
                  this.state.relevantSubjects
                }
                type={_.get(
                  requestData,
                  "requestInfo.details.testDetails.type",
                  "N/A"
                )}
                orderNoteBy={getRequestCreatorName(requestData)}
                note={
                  requestData &&
                  requestData.requestInfo &&
                  requestData.requestInfo.orderNote
                }
                attachments={_.get(
                  requestData,
                  "requestInfo.orderNoteAttachments",
                  []
                )}
                contentsubType={contentsubType}
                requestContentType={requestContentType}
                requestData={requestData}
              />
              <Grid className={classes.customCard}>
                <SelectContentOwners
                  contentsubType={contentsubType}
                  requestData={requestData}
                  requestContentType={requestContentType}
                  transferToParent={this.handleOwnerChange}
                  toShowTestOwners={toShowTestOwners}
                  handleRelevantOwnerOnly
                />
              </Grid>
            </Grid>

            <Grid item xs={1}>
              <Grid>
                <MyPATCollapseSection>
                  <MyPATCollapseSectionItem
                    sectionKey="requestInfo"
                    sectionName="Request Info"
                    icon="/assets/svg/new-info.svg"
                  >
                    <RequestInfo isRequested={true} requestData={requestData} />
                  </MyPATCollapseSectionItem>
                </MyPATCollapseSection>
              </Grid>
              <Grid className={classes.sidePanel}>
                {/* <SectionInContent
                  onSectionsValidtyChange={this.onSectionsValidtyChange}
                  showDraftPercentage
                >
                  <SectionInContentItem
                    value={requestData}
                    validate={validateSelectContentOwners}
                  >
                    Select Content Owners
                  </SectionInContentItem>
                </SectionInContent> */}
              </Grid>
            </Grid>
          </Grid>
        </DialogLarge>
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  contentsubType: _.get(state, "testTemplate.contentSubType.list", {}),
  user: state.loginData.userData.authenticatedUser,
  selectedQuestionCodes:
    state.contentRequestReducer.contentRequestCreateReducer
      .selectedQuestionCodes,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getContentSubType,
      addSubject,
      fetchSubjects,
      setActiveTab,
      setSelectedQuestionCodes:
        contentRequestCreateActions.setSelectedQuestionCodes,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(EditCreateOwner));
